import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenService } from '@auth'; // Adjust the path as necessary
import { Router } from '@angular/router';
import { MessageService } from '@shared';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private messageService: MessageService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = this.tokenService.token.getValue();

    let authorizedReq = req;
    if (token) {
      // Clone the request and add the Authorization header
      authorizedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
    }

    return next.handle(authorizedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token is expired or invalid, attempt to refresh it
          return this.tokenService.refreshToken().pipe(
            switchMap((tokenFetchSucceeded) => {
              if (tokenFetchSucceeded) {
                const newToken = this.tokenService.token.getValue();
                const newAuthorizedReq = req.clone({
                  headers: req.headers.set(
                    'Authorization',
                    `Bearer ${newToken}`,
                  ),
                });
                return next.handle(newAuthorizedReq);
              } else {
                this.messageService.error('Token refresh failed');
                return throwError(() => error);
              }
            }),
          );
        } else {
          return throwError(() => error);
        }
      }),
    );
  }
}
